import React from "react";
import {
  Collapse,
  Icon,
  Row,
  Spin,
  Col,
  Layout, Button,
  message, Select,
} from "antd";
import moment from "moment";
import TableWrapper from '../elements/TableWrapper';
import img from './../../assets/img/At the office-pana 1.png';
import MiCompAPI from "./../../util/api";

const { Panel } = Collapse;
const { Content } = Layout;
const { Option } = Select;
class Enrollments extends React.Component {

  constructor(props) {
    super(props);


    this.columns = [
      {
        title: 'File Name',
        dataIndex: 'file_Name',
        sorter: (a, b) => a.file_Name.localeCompare(b.file_Name),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'File Type ',
        dataIndex: 'file_Type',
        sorter: (a, b) => a.file_Type.localeCompare(b.file_Type),
        sortDirections: ["descend", "ascend"]
      }, {
        title: 'Date Uploaded ',
        dataIndex: 'uploaded_On',
        sorter: (a, b) => new Date(a.uploaded_On) - new Date(b.uploaded_On),
        render: (text, record) =>
          record["uploaded_On"] !== null && record["uploaded_On"] !== ""
            ? moment(record["uploaded_On"]).format("MM/DD/YYYY HH:mm:ss")
            : "",
        sortDirections: ["descend", "ascend"]
      }, {
        title: 'Date Processed ',
        dataIndex: 'processed_On',
        sorter: (a, b) => new Date(a.processed_On) - new Date(b.processed_On),
        render: (text, record) =>
          record["processed_On"] !== null && record["processed_On"] !== ""
            ? moment(record["processed_On"]).format("MM/DD/YYYY HH:mm:ss")
            : "",
        sortDirections: ["descend", "ascend"]
      }, {
        title: 'Status',
        dataIndex: 'status',
        sorter: (a, b) => a.status.localeCompare(b.status),
        sortDirections: ["descend", "ascend"],


      }, {
        title: 'Action ',
        render: (text, record) => {

          return (
            <i style={{ display: record.status !== 'Success' ? 'flex' : 'none' }} title="Download" className="fa fa-download fa-blue" onClick={() => { window.open(record.error_file_Path) }}></i>
          );
        }


      }];

    this.state = {
      enrolments: [],
      isloading: false,
      downloadTemlateType: null,
      uploadfile: null,
      enrollment: null,
      carrier: [],
      client_id: null,
      plan_id: null,
      usstates: [],
      state: null,
      loas: [],
      loa: null,
      plans: [],
      state_id: null,
      planerror: null,
      clienterror: null,
      loaerror: null,
      stateerror: null,
      enId: null,
      fileType: null,
      fileError: null,
      fileTypeError: null,
      error_file_Path: null,
      masterstate: [],
      bulkfileDataErrors:[]

    }
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  generateEnorlmentID = () => {
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    if (role !== "carrier") {
      if (!this.state.client_id) {
        this.setState({
          clienterror: "Please select Carrier"
        })

      }
      if (!this.state.plan_id) {
        this.setState({
          planerror: "Please select Plan"
        })
      }
      if (!this.state.loa) {
        this.setState({
          loaerror: "Please select LOA"
        })
      }
      if (!this.state.state_id) {
        this.setState({
          stateerror: "Please select State"
        })
      }
      if (this.state.plan_id && this.state.client_id && this.state.loa && this.state.state_id) {
        this.setState({
          clienterror: null,
          loaerror: null,
          stateerror: null,
          planerror: null,
          enId: "Enrollment Load Id: " + this.state.client_id + "_" + this.state.plan_id + "_" + this.state.state_id
        })
      }
    } else {
      if (!this.state.plan_id) {
        this.setState({
          planerror: "Please select Plan"
        })
      }
      if (!this.state.state_id) {
        this.setState({
          stateerror: "Please select State"
        })
      }
      if (this.state.plan_id && this.state.state_id) {
        this.setState({
          clienterror: null,
          loaerror: null,
          stateerror: null,
          planerror: null,
          enId: "Enrollment Load Id: " + this.state.plan_id + "_" + this.state.state_id
        })
      }
    }

  }

  componentDidMount = () => {
    this.getFileStatus();
    this.getClientMasters();
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    if (role === "carrier") {
      this.GetCarrierPlans();
    }
  }
  getClientMasters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            loas: data.lobs,
            masterstate: data.states
          });
        }
      },
      ["LOB", "STATE"]
    );
  }
  getCarries = (e) => {
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    if (role === "carrier") {



      this.setState({
        state_id: e,

      });
    } else {
      this.api.invoke(
        "GetContractCarrierByLoa/" + this.state.loa + "/" + e,
        "get",
        (data, success) => {
          if (success) {

            var state_id = "";
            this.state.usstates.map(x => {
              if (x.name === e)
                state_id = x.id
            }

            );
            this.setState({
              state_id: state_id,
              state: e,
              carrier: data.data,
            });
          }
        }

      );
    }

  }
  GetStatebyLoAState = (e) => {
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    if (role !== "carrier") {

      this.api.invoke(
        "GetStatebyLoAState/" + e,
        "get",
        (data, success) => {
          if (success) {
            this.setState({
              loa: e,
              usstates: data.data
            });
          }
        }

      );
    }

  }
  getFileStatus = () => {
    this.setState({
      isloading: true
    });
    this.api.invoke(
      "GetEnrolments",
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              enrolments: data.data,

            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
        this.setState({
          isloading: false
        });
      },
      undefined,
      undefined
    );
  }

  GetCarrierPlans = () => {
    this.api.invoke(
      "GetCarrierPlans",
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              plans: data.data,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 4);
          }
        }
      },
      undefined,
      undefined
    );
  }
  GetPlansByCarrier = (client_id) => {
    this.setState({
      client_id: client_id
    });
    this.api.invoke(
      "GetPlansByCarrier/" + client_id + "/" + this.state.loa + "/" + this.state.state_id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              plans: data.data,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 4);
          }
        }
      },
      undefined,
      undefined
    );
  }
  changePlan = (e) => {
    this.setState({ plan_id: e })
  }
  changefiletype = (e) => {
    this.setState({ fileType: e })
  }


  downloadTemlateChange = (e) => {

    this.setState({
      downloadTemlateType: e

    })

  }

  onSubmitOfDownloadTEmplate = () => {

    if (this.state.downloadTemlateType) {
      if (this.state.downloadTemlateType === '1') {
        window.open(process.env.REACT_APP_SAMPLE_URL+"sample-enrolments/EnrollmentQA.xlsx");
      }
      else {
        window.open(process.env.REACT_APP_SAMPLE_URL+"sample-enrolments/EnrolmentCSVSampleQA.csv");
      }
    }
    else {
      message.error("Please select Document Type", 3)
    }
  }

  uploadFile = async (evt) => {

    var f = evt.target.files[0];

    if (f.size > 15728640) {
      message.warning("File size must under 15MiB!", 3);
    }
    if ((this.state.fileType === "xl" && (f.name.split('.')[1] !== 'xls' && f.name.split('.')[1] !== 'xlsx')) || (this.state.fileType === "csv" && f.name.split('.')[1] !== 'csv') || (this.state.fileType === "834" && f.name.split('.')[1] !== 'txt')) {
      message.error("Invalid file format!, Plese upload proper file.", 10)
    }
    this.setState({
      fileData: {
        base64file: await this.convertBase64(f),
        name: f.name,
        size: f.size
      }
    });
  }

  bulkuploadFile = async (evt) => {
    
    var bulkfileData = [];

    for (let f of evt.target.files) {
      bulkfileData.push({
        base64file: await this.convertBase64(f),
        name: f.name,
        size: f.size
      })
    }



    this.setState({
      bulkfileData: bulkfileData
    });
  }
  convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file)
      fileReader.onload = () => {
        resolve(fileReader.result);
      }
      fileReader.onerror = (error) => {
        reject(error);
      }
    })
  }
  submitFile = () => {

    if (!this.state.fileType) {
      this.setState({
        fileTypeError: "Please select file type"
      })
    }
    if (!this.state.fileData) {
      this.setState({
        fileError: "Please upload file"
      })
    } else {
      if (this.state.fileData.size > 15728640) {
        this.setState({
          fileError: "Filesize must under 15MB!"
        })
      } else if ((this.state.fileType === "xl" && (this.state.fileData.name.split('.')[1] !== 'xls' && this.state.fileData.name.split('.')[1] !== 'xlsx')) || (this.state.fileType === "csv" && this.state.fileData.name.split('.')[1] !== 'csv') || (this.state.fileType === "834" && this.state.fileData.name.split('.')[1] !== 'txt')) {
        this.setState({
          fileError: "Invalid file format!, Plese upload proper file."
        })
      } else {
        if (this.state.fileType && this.state.fileData) {
          this.setState({
            fileError: null,
            fileTypeError: null,
            isloading: true
          })
          var data = {
            file_Name: this.state.fileData.name,
            file_Type: this.state.fileType,
            file_Path: this.state.fileData.base64file
          }

          this.api.invoke(
            "SaveEnrolment",
            "post",
            (data, success) => {
              if (success) {
                if (data.statusCode === 200) {
                  message.destroy();
                  message.success(data.statusMessage, 6);
                  this.setState({
                    fileData: null,
                    isloading: false
                  });
                  this.getFileStatus();
                } else {
                  message.destroy();
                  message.error(data.statusMessage, 4);
                }
              }
              this.setState({
                isloading: false
              });
            },
            data
          );

        }
      }

    }
  }
  submitFiles = () => {


    if (!this.state.bulkfileData) {
      this.setState({
        fileError: "Please upload file"
      })
    } else {

      if (this.state.bulkfileData) {

        this.api.invoke(
          "UploadEnrolment",
          "post",
          (data, success) => {
            if (success) {
              if (data.statusCode === 200) {
                message.destroy();
                message.success(data.statusMessage, 6);
                this.setState({
                  bulkfileData: null,
                  bulkfileDataErrors:data.data,
                  isloading: false
                });
                this.getFileStatus();
              } else {
                message.destroy();
                message.error(data.statusMessage, 4);
              }
            }
            this.setState({
              isloading: false
            });
          },
          this.state.bulkfileData
        );

      }
    }
  }
  handleFormSubmit = event => {
    event.preventDefault();
  }

  render() {
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    return (

      <Content>
        <div className="mi_main1">
          <div className="mi_box">
            <Row span={24}>
              <Col span={18}>
                <h4 className="mi_box_h4">Enrollments</h4>
              </Col>
              <Col span={6}>
                <img alt="example" style={{ height: '182px', marginTop: '-80px' }} src={img} />
              </Col>
            </Row>
          </div>
          <Collapse accordion={true}
            style={{marginLeft:"-4px"}}
            expandIconPosition='right'
            expandIcon={({ isActive }) => <Icon type="down" rotate={isActive ? 180 : 0}/>}
          >
            {role !== "carrier" ?
              <Panel header={<p className="mi_acc_header">Generate Enrollment Load ID</p>} key="1" >

                <Row span={24}>
                  <Col sm={12}>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">LOA</legend>
                      <Select className="mi_input" suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />}
                        optionFilterProp="children"
                        showSearch={true}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={this.GetStatebyLoAState}

                        placeholder="Please Select LOA *">
                        {this.state.loas ? this.state.loas.map(tag => <Option value={tag.name} key={tag.name}>{tag.name}</Option>) : ""}
                      </Select>
                    </fieldset>
                    {this.state.loaerror ? <p style={{ color: 'red', marginLeft: '8px' }}>{this.state.loaerror}</p> : ""}

                  </Col>
                  <Col sm={12}>

                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">State</legend>
                      <Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />}
                        showSearch={true}
                        optionFilterProp="children"
                        onMouseEnter={() => this.setState({ stateerror: !this.state.loa ? "Please select LOA First" : null })}

                        onChange={this.getCarries.bind(this)}

                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        } className="mi_input" placeholder="Please Select State *"  >
                        {this.state.usstates.map(tag => <Option value={tag.name} key={tag.name}>{tag.name}</Option>)}
                      </Select>
                    </fieldset>
                    {this.state.stateerror ? <p style={{ color: 'red', marginLeft: '8px' }}>{this.state.stateerror}</p> : ""}

                  </Col>
                </Row>
                <Row span={24}>
                  <Col span={12}>
                    <fieldset className="mi_input_pop">

                      <legend className="legend-font">Carrier</legend>
                      <Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                        onChange={this.GetPlansByCarrier.bind(this)}
                        onMouseEnter={() => this.setState({ clienterror: !this.state.state_id ? "Please select State First" : null })}

                        optionFilterProp="children"
                        showSearch={true}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Please Select Carrier *">
                        {this.state.carrier ? this.state.carrier.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>) : ""}
                      </Select>

                    </fieldset>
                    {this.state.clienterror ? <p style={{ color: 'red', marginLeft: '8px' }}>{this.state.clienterror}</p> : ""}
                  </Col>
                  <Col span={12}>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Plan</legend>
                      <Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                        onChange={this.changePlan.bind(this)}
                        onMouseEnter={() => this.setState({ planerror: !this.state.client_id ? "Please select Carrier First" : null })}
                        optionFilterProp="children"
                        showSearch={true}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Please Select Plan *">
                        {this.state.plans ? this.state.plans.map(tag => <Option value={tag.code} key={tag.code}>{tag.name}</Option>) : ""}

                      </Select>
                    </fieldset>
                    {this.state.planerror ? <p style={{ color: 'red', marginLeft: '8px' }}>{this.state.planerror}</p> : ""}
                  </Col>
                </Row>
                <Row span={24} style={{ marginTop: '20px', float: 'right', marginRight: "12px" }}>


                  <Col span={24}>
                    <Button type="primary" className="submit-button" style={{ marginBottom: "16px", float: 'right', }} onClick={this.generateEnorlmentID}>
                      Submit
                    </Button>
                    {this.state.enId ? <span style={{ float: 'right', fontWeight: "bold", margin: 'none', fontSize: "large", marginTop: '10px' }}>{this.state.enId}</span> : ""}

                  </Col>

                </Row>
              </Panel>
              : <Panel header={<p className="mi_acc_header">Generate Enrollment Load ID</p>} key="1" >

                <Row span={24}>
                  <Col span={12}>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Plan</legend>
                      <Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                        onChange={this.changePlan.bind(this)}
                        optionFilterProp="children"
                        showSearch={true}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Please Select Plan *">
                        {this.state.plans ? this.state.plans.map(tag => <Option value={tag.code} key={tag.code}>{tag.name}</Option>) : ""}

                      </Select>
                    </fieldset>
                    {this.state.planerror ? <p style={{ color: 'red', marginLeft: '8px' }}>{this.state.planerror}</p> : ""}

                  </Col>
                  <Col sm={12}>

                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">State</legend>
                      <Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />}
                        showSearch={true}
                        optionFilterProp="children"

                        onChange={this.getCarries.bind(this)}

                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        } className="mi_input" placeholder="Please Select State *"  >
                        {this.state.masterstate.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>)}
                      </Select>
                    </fieldset>
                    {this.state.stateerror ? <p style={{ color: 'red', marginLeft: '8px' }}>{this.state.stateerror}</p> : ""}

                  </Col>
                </Row>

                <Row span={24} style={{ marginTop: '20px', float: 'right', marginRight: "12px" }}>


                  <Col span={24}>
                    <Button type="primary" className="submit-button" style={{ marginBottom: "16px", float: 'right', }} onClick={this.generateEnorlmentID}>
                      Submit
                    </Button>
                    {this.state.enId ? <span style={{ float: 'right', fontWeight: "bold", margin: 'none', fontSize: "large", marginTop: '10px' }}>{this.state.enId}</span> : ""}

                  </Col>

                </Row>
              </Panel>}



            <Panel header={<p className="mi_acc_header">Upload Enrollments </p>} key="2" >
              <Spin spinning={this.state.isloading} size="large" tip="Loading..." >

                <Row span={24}>
                  <Col span={12}>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">File Type</legend>
                      <Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                        optionFilterProp="children"
                        showSearch={true}
                        onChange={this.changefiletype.bind(this)}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Please Select">
                        <Option value="xl">Mi Comp Excel</Option>
                        <Option value="csv">Mi Comp CSV</Option>
                        <Option value="834">834 Txt File</Option>

                      </Select>
                    </fieldset>
                    {this.state.fileTypeError ? <p style={{ color: 'red', marginLeft: '8px' }}>{this.state.fileTypeError}</p> : ""}

                  </Col>
                  <Col span={12}>
                    <fieldset>
                      <legend className="legend-font">Upload File</legend>
                      <input type="file" style={{ marginLeft: '-5px' }} id="files" name="files" onChange={this.uploadFile} />

                      {/* <FileBase64  onDone={this.uploadFile} /> */}
                    </fieldset>
                    {this.state.fileError ? <p style={{ color: 'red', marginLeft: '8px' }}>{this.state.fileError}</p> : ""}

                  </Col>
                </Row>
                <Row span={24} style={{ marginTop: '20px', float: 'right', marginRight: "12px" }}>

                  <Col span={24}>
                    <Button type="primary" className="submit-button" style={{ marginBottom: "16px" }}
                      onClick={this.submitFile}
                    >
                      {/* <i className="fa fa-upload" aria-hidden="true"></i> */}
                      Upload File
                    </Button>

                  </Col>

                </Row>
              </Spin>
            </Panel>

            {role !== "carrier" ? "" : <Panel header={<p className="mi_acc_header">Bulk Upload Enrollments </p>} key="5" >
              <Spin spinning={this.state.isloading} size="large" tip="Loading..." >

                <Row span={24}>

                  <Col span={12}>
                    <fieldset>
                      <legend className="legend-font">Upload File</legend>
                      <input type="file" multiple style={{ marginLeft: '-5px' }} id="files" name="files" onChange={this.bulkuploadFile} />

                      {/* <FileBase64  onDone={this.uploadFile} /> */}
                    </fieldset>
                    {this.state.bulkfileDataErrors ?this.state.bulkfileDataErrors.map(x=><p style={{ color: 'red', marginLeft: '8px' }}>{x}</p>)  : ""}

                  </Col>
                </Row>
                <Row span={24} style={{ marginTop: '20px', float: 'right', marginRight: "12px" }}>

                  <Col span={24}>
                    <Button type="primary" className="submit-button" style={{ marginBottom: "16px" }}
                      onClick={this.submitFiles}
                    >
                      {/* <i className="fa fa-upload" aria-hidden="true"></i> */}
                      Upload File
                    </Button>

                  </Col>

                </Row>
              </Spin>
            </Panel>}



            <Panel header={<p className="mi_acc_header">Download Template </p>} key="3" >

              <Row span={24}>
                <Col span={12}>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">Download Template </legend>
                    <Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                      showSearch
                      onChange={this.downloadTemlateChange}
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      filterSort={(optionA, optionB) =>
                        optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                      }
                    >
                      <Option value="1">Mi Comp Excel</Option>
                      <Option value="2">Mi Comp CSV</Option>

                    </Select>
                  </fieldset>
                </Col>
              </Row>

              <Row span={24} style={{ marginTop: '20px', marginRight: "20px" }}>


                <Col span={12}>
                  <Button type="primary" className="submit-button" style={{ float: 'right' }} onClick={() => this.onSubmitOfDownloadTEmplate()}>

                    {/* <i className="fa fa-download" aria-hidden="true"></i> */}
                    Download File     </Button>

                </Col>

              </Row>

            </Panel>
            <Panel header={<p className="mi_acc_header">Enrollment File Status </p>} key="4" >
              <Row span={18} style={{ marginLeft: '16px', marginRight: '18px', marginTop: '-25px' }} >
                <TableWrapper style={{ marginLeft: '14px', marginRight: '14px' }} columns={this.columns} rowKey="id" data={this.state.isloading ? null : this.state.enrolments} loading={this.state.isloading} search={true} />
              </Row>
            </Panel>
          </Collapse>
        </div>
      </Content>
    );
  }

}
export default Enrollments;
